export default __webpack_public_path__ + "static/media/one-page-brochure-2.24d72762.png";